export default "__VITE_ASSET__3bRS3GYO__"